import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths'
import React, { useCallback, useContext, useMemo, useState } from 'react'
import { seasonalHelpers } from '../cnr/reducers/reducerHelpers/seasonalHelpers';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { useSeasonalData } from './useSeasonals';
import { useSportsCollection } from './useSportsCollection';
import { where, writeBatch } from 'firebase/firestore';
import _ from 'lodash';
import { dataFix } from 'global/common/dataFix';
import { _teamsFoundTypes } from '../cnr/reducers/reducerHelpers/seasonSportsMatchData';

const _rosterCollectionNames = {
  teamRosters: {
    parentDoc: '_teamRosters',
    mapField: 'teamRosters',
  },
  teamStaff: {
    parentDoc: '_teamStaff',
    mapField: 'teamStaff',
  },
  // teamRosterz: {
  //   parentDoc: '_teamRosterz',
  //   mapField: 'teamRosterz',
  // },
}

const docLimits = {
  full: 1048576,
  controlled: 900000
}

export const useTeamRosters = () => {

  const _allowRosterUpdate = true

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns ?? {}
  const { mainDb } = app_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { currentSeason_info, parentDataKeys, teams_info, tournaments_info, sportsAccess_teams, gls_teams } = sportsSeason_state ?? {}
  const { sportsKey, currentSeason, _sportsAbr } = currentSeason_info ?? {}
  const { teams: access_teams } = sportsAccess_teams ?? {}
  const { teams, rosters } = teams_info ?? {}
  const { tournaments } = tournaments_info ?? {}

  const { getSportsCollectionItem } = useSportsCollection()

  // const aaa = useMemo(async () => {
  //   const zzz = await getSportsCollectionItem({ collectionName: '_matches_seasonal', subCollectionName: 'matches' })
  //   console.log('zzz', zzz)
  //   return zzz
  // }, [])

  const _sdh = useSeasonalData()

  const [updating, setUpdating] = useState()

  const updateRoster = useCallback(async ({ teamKey, roster }) => {

    const rc = _rosterCollectionNames.teamRosters
    const pd = rc.parentDoc
    const mf = rc.mapField

    setUpdating(true)
    const batch = writeBatch(mainDb);

    const dataToUpdate = dataFix.cleanForFirebase(roster, { removeUnderscore: true })

    console.group('updateRoster')
    console.group('dataToUpdate', dataToUpdate)

    const _pks = seasonalHelpers.getPks(pathViews, currentSeason, sportsKey, ['teams', 'sportsYears'])
    const _sportsYearCollectionItem = await _sdh.getSports_collectionItem(_pks, pd, true)

    if (!_sportsYearCollectionItem) {
      // add a new doc
      const docKey = database_fns.get_docKey()
      const newDocKey = `${_sportsAbr}_${docKey}`
      const refPath = createRefPath_event(pathViews, [pd, newDocKey])
      const dtu = {
        parentKeys: _pks,
        [mf]: {
          [teamKey]: dataToUpdate
        }
      }
      console.log('refPath', refPath)
      console.log('dtu', dtu)
      database_fns.set_doc(refPath, dtu, false, null, batch); // Assuming doc_update returns a promise
    } else {
      const { _itemKey, teamKeys } = _sportsYearCollectionItem ?? {}
      const _teamKeys = teamKeys || []
      if (!_.includes(_teamKeys, teamKey)) {
        _teamKeys.push(teamKey)
      }
      const refPath = createRefPath_event(pathViews, [pd, _itemKey])
      const dtu = {
        teamKeys: _teamKeys,
        [`${mf}.${teamKey}`]: { ...dataToUpdate }
      }
      database_fns.update_doc(refPath, dtu, null, batch); // Assuming doc_update returns a promise
    }

    if (_allowRosterUpdate) {
      await batch.commit()
      setUpdating(false)
    }

    console.groupEnd()
  }, [])

  const getTeamRosters = useCallback(async ({ callback }) => {

    const rc = _rosterCollectionNames.teamRosters
    const pd = rc.parentDoc
    const mf = rc.mapField

    const cb = (data) => {
      if (!_.isEmpty(data)) {
        const fullRosters = buildUniqueTeamRosters(data)
        const [key, value] = _.toPairs(data)[0];
        const fieldValue = value?.[mf]

        // updateOther(mainDb, database_fns, _sdh, pathViews, currentSeason, sportsKey, fullRosters)

        callback({
          parentKey: key,
          [mf]: fieldValue,
          fullRosters
        })
      } else {
        callback({ [mf]: null })
      }
    }
    const refPath = createRefPath_event(pathViews, [pd])
    const wheres = getWheres_sport({ pathViews, currentSeason, sportsKey, anyYear: true })
    console.log('refPath', refPath)
    database_fns.get_data({
      refPath,
      callback: cb,
      wheres
    })
  }, [])

  const getStaff = useCallback(async ({ callback, activeYear, anyYear }) => {
    const cb = (data) => {
      if (!_.isEmpty(data)) {
        const fullStaff = buildUniqueTeamStaff(data)
        const [key, value] = _.toPairs(data)[0];
        const fieldValue = value?.[_rosterCollectionNames.teamStaff.mapField]
        callback({ parentKey: key, [_rosterCollectionNames.teamStaff.mapField]: fieldValue, fullStaff })
      } else {
        callback({ [_rosterCollectionNames.teamStaff.mapField]: null })
      }
    }
    const refPath = createRefPath_event(pathViews, [_rosterCollectionNames.teamStaff.parentDoc])
    const wheres = getWheres_sport({ pathViews, anyYear: true, currentSeason: activeYear || currentSeason, sportsKey })
    database_fns.get_data({
      refPath,
      callback: cb,
      wheres
    })
  }, [])

  const filterRosters = useCallback(({ currentSeason, teamRosters }) => {
    if (!teamRosters) return;
    const _teamRosters = {}
    _.forEach(teamRosters, (teamRoster, teamKey) => {
      const latestSeason = currentSeason || _.max(
        _.flatMap(teamRoster, player => _.map(_.keys(player.seasons), Number))
      );
      const _currentPlayers = _.pickBy(teamRoster, player => {
        const playerLatestSeason = _.max(_.map(_.keys(player.seasons), Number));
        return playerLatestSeason === latestSeason;
      });
      _teamRosters[teamKey] = _currentPlayers
    })
    return _teamRosters
  }, [])

  return { updating, getTeamRosters, getStaff, updateRoster, allowRosterUpdate: _allowRosterUpdate, filterRosters }
}

const getWheres_sport = ({ pathViews, currentSeason, sportsKey, anyYear }) => {
  const _pks = seasonalHelpers.getPks(pathViews, currentSeason, sportsKey, anyYear ? ['teams', 'sportsYears'] : ['teams'])
  const wheres = _.map(_pks, (value, pk) => {
    return where('parentKeys.' + pk, '==', value)
  })
  return wheres
}

const buildUniqueTeamRosters = (team_rosters) => {

  const teams = {};

  _.forEach(team_rosters, season => {

    const { teamRosters, parentKeys } = season;
    const { sportsYears: sportsYear } = parentKeys;

    // const _teamRosters =  teamRosters

    _.forEach(teamRosters, (players, teamKey) => {

      teams[teamKey] ??= {};

      _.forEach(players, player => {

        const { lastName, firstName, graduationYear, seasons } = player

        const _seasonKeys = seasons ? _.keys(seasons) : []

        const playerKey = [
          lastName?.toLowerCase(),
          firstName?.toLowerCase(),
          graduationYear
        ].join("_");

        if (!teams[teamKey][playerKey]) {

          // console.log('player', player)

          teams[teamKey][playerKey] = {
            ..._.omit(player, [
              "_gsid",
              "_itemKey",
              "uniformNumber",
              "height",
              "playerPosition"
            ]),
            seasons: seasons
          };
        }

        // teams[teamKey][playerKey].seasons[sportsYear] = {
        //   uniformNumber: player.uniformNumber,
        //   height: player.height,
        //   positions: _.uniq(
        //     _.compact(
        //       _.castArray(player.playerPosition)
        //     )
        //   )
        // };

      });
    });
  });

  return teams;
};

const buildUniqueTeamStaff = (team_staff) => {

  const teams = {};

  _.forEach(team_staff, season => {

    const { teamStaff, parentKeys } = season;
    const { sportsYears: sportsYear } = parentKeys;

    _.forEach(teamStaff, (players, teamKey) => {

      teams[teamKey] ??= {};

      _.forEach(players, player => {

        const playerKey = [
          player.lastName?.toLowerCase(),
          player.firstName?.toLowerCase(),
        ].join("_");

        if (!teams[teamKey][playerKey]) {

          teams[teamKey][playerKey] = {
            ...removeEmptyValues(
              _.omit(player, [
                "_gsid",
                "_itemKey",
                "uniformNumber",
                "height",
                "playerPosition"
              ])
            ),
            seasons: {}
          };
        }

        teams[teamKey][playerKey].seasons[sportsYear] = removeEmptyValues({
          uniformNumber: player.uniformNumber,
          height: player.height,
          positions: _.uniq(_.compact(_.castArray(player.playerPosition)))
        });

        // teams[teamKey][playerKey].seasons[sportsYear] = {
        //   uniformNumber: player.uniformNumber,
        //   height: player.height,
        //   positions: _.uniq(
        //     _.compact(
        //       _.castArray(player.playerPosition)
        //     )
        //   )
        // };

      });
    });
  });

  return teams;
};

const removeEmptyValues = (obj) => {
  if (_.isArray(obj)) {
    const arr = obj
      .map(removeEmptyValues)
      .filter(v =>
        !_.isNil(v) &&
        v !== "" &&
        !(_.isArray(v) && v.length === 0) &&
        !(_.isPlainObject(v) && _.isEmpty(v))
      );

    return arr;
  }

  if (_.isPlainObject(obj)) {
    return _.pickBy(
      _.mapValues(obj, removeEmptyValues),
      v =>
        !_.isNil(v) &&
        v !== "" &&
        !(_.isArray(v) && v.length === 0) &&
        !(_.isPlainObject(v) && _.isEmpty(v))
    );
  }

  return obj;
};

const updateOther = async (mainDb, database_fns, _sdh, pathViews, currentSeason, sportsKey, fullRosters) => {

  const _allowUpdateOther = false

  const rc = _rosterCollectionNames.teamRosters
  const pd = rc.parentDoc
  const mf = rc.mapField

  const _pks = seasonalHelpers.getPks(pathViews, currentSeason, sportsKey, ['teams', 'sportsYears'])
  const _sportsYearCollectionItem = await _sdh.getSports_collectionItem(_pks, pd, true)

  if (_sportsYearCollectionItem) {
    const { _itemKey } = _sportsYearCollectionItem ?? {}
    const refPath = createRefPath_event(pathViews, [pd, _itemKey])
    const dtu = {
      [`${mf}`]: { ...fullRosters }
    }
    console.log('_pks', _pks)
    console.log('refPath', refPath)
    console.log('dtu', dtu)

    const batch = writeBatch(mainDb);
    database_fns.update_doc(refPath, dtu, null, batch); // Assuming doc_update returns a promise

    if (_allowUpdateOther) {
      await batch.commit()
    }

  }

  // const dtu = {
  //   teamKeys: _teamKeys,
  //   [`${mf}.${teamKey}`]: { ...dataToUpdate }
  // }
  // database_fns.update_doc(refPath, dtu, null, batch); // Assuming doc_update returns a promise
}